import { RefreshCcw } from 'lucide-react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Input } from 'src/shared/components/ui'
import { Button } from 'src/shared/components/ui/button'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const WebsiteUrlForm = ({
  websiteUrlInput,
  onWebsiteUrlInputChange,
  isSubmitting,
  onSubmit,
  mode = 'new',
}) => {
  const { t } = useLocalization()

  const description =
    mode === 'refresh'
      ? t(
          'Re-fetch logos from your website',
          'Hämta om logotyper från din webbplats'
        )
      : t('Add website URL to fetch logos', 'Hämta logos från din webbplats')

  const actionLabel =
    mode === 'refresh' ? t('Re-fetch', 'Hämta om') : t('Fetch', 'Hämta')

  return (
    <Column className="mt-4">
      <p className="text-xs text-muted-foreground ml-0.5">{description}</p>

      <Row className="gap-2 items-center mt-1">
        <Input
          placeholder={t('e.g., yourcompany.com', 't.ex., yourcompany.com')}
          value={websiteUrlInput}
          onChange={(e) => onWebsiteUrlInputChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !isSubmitting && websiteUrlInput.trim()) {
              onSubmit()
            }
          }}
          className="text-xs w-full"
          disabled={isSubmitting}
        />

        <Button
          variant="ghost"
          onClick={onSubmit}
          disabled={isSubmitting || !websiteUrlInput.trim()}
        >
          <RefreshCcw className="w-3 h-3 mr-1.5" />
          {isSubmitting ? t('Saving...', 'Sparar...') : actionLabel}
        </Button>
      </Row>
    </Column>
  )
}
